import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SubjectsData } from './subjectsData';

const routes: Routes = [
  {
    path: 'subjects',
    component: SubjectsData,
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SubjectsDataRoutingModule {}
